import { apiClient } from './client'

export type SubscriptionBillingSource = 'Unknown' | 'AppStore' | 'GooglePlay'
export type SubscriptionTier = 'Free' | 'PremiumMonthly' | 'PremiumAnnual'

export type RevenueSubscriptionCounts = {
  totalSubscriptions: number
  productionStoreManaged: number
  activePaid: number
  activePaidWithKnownPrice: number
  activePaidMissingPrice: number
  trial: number
  pastDue: number
  canceledWithAccess: number
  expiredOrEnded: number
  revokedOrRefunded: number
  sandboxOrFake: number
  adminOrUnknownSource: number
}

export type RevenueCurrencySummary = {
  currency: string
  estimatedMonthlyRevenue: number
  estimatedAnnualRunRate: number
  activePaidSubscriptions: number
  knownPriceSubscriptions: number
  missingPriceSubscriptions: number
}

export type RevenueBreakdownItem = {
  billingSource: SubscriptionBillingSource
  billingSourceLabel: string
  tier: SubscriptionTier
  currency: string
  activePaidSubscriptions: number
  knownPriceSubscriptions: number
  missingPriceSubscriptions: number
  estimatedMonthlyRevenue: number
  estimatedAnnualRunRate: number
}

export type RevenueSummary = {
  generatedAtUtc: string
  estimateBasis: string
  counts: RevenueSubscriptionCounts
  currencies: RevenueCurrencySummary[]
  breakdown: RevenueBreakdownItem[]
  caveats: string[]
}

export async function getRevenueSummary() {
  const { data } = await apiClient.get<RevenueSummary>('/api/admin/revenue/summary')
  return data
}
